import React, { Dispatch, SetStateAction } from 'react';

import { List, Tag, Flex, Checkbox } from 'antd';
import { ObserverCreationDate, ObserverName, SeverityColor } from 'src/pages/store/components/ObserversList/styles';
import { Observer } from 'src/interfaces/entities/observer';
import dayjs from 'dayjs';
import { useGetSeveritiesQuery } from 'src/redux/services/centralApi';

export default function ObserversList(
	{
		observers,
		module,
		setSelectedObservers,
		selectedObservers,
	}: {
		observers: Array<Observer>,
		module: boolean,
		setSelectedObservers: Dispatch<SetStateAction<Array<string>>>
		selectedObservers: Array<string>
	}
) {
	const { data: severitiesData, } = useGetSeveritiesQuery();

	return (
		<List
			size='small'
			dataSource={observers}
			renderItem={(item) => {
				const severity = severitiesData?.find(sev =>
					sev.severity_id === item.severity_id
				);

				let observerName: string = item.name;
				if (item.conditions && item.name.includes('{{')) {
					Object.entries(item.conditions).forEach(([ string, condition, ]) => {
						if (condition.type !== 'sql') {
							const conditionValue: string = condition.value?.toString() ?? '';
							observerName = observerName.replace(`{{${string}}}`, conditionValue);
						}
					});
				}

				return <List.Item style={{ height: '100%', }}>
					<Flex vertical>
						<Flex gap={4} align='end'>
							<Flex align='center' gap={8}>
								<SeverityColor
									style={{
										backgroundColor: severity?.color,
									}}
								/>
								<ObserverName>
									{observerName}
								</ObserverName>
							</Flex>
							<ObserverCreationDate>
								{dayjs(item.creation_date).format('DD/MM/YYYY')}
							</ObserverCreationDate>
						</Flex>
						<Flex wrap='wrap' gap={4}>
							{item.tags && item.tags.map((tag, i) =>
								<Tag
									key={i}
									style={{ margin: 0, }}
								>
									{tag}
								</Tag>
							)}
						</Flex>
					</Flex>
					{module &&
						<Checkbox
							checked={selectedObservers.some(value => value === item.observer_id)}
							onChange={(e) => setSelectedObservers(prev => {
								const checked = e.target.checked;
								if(prev.includes(item.observer_id) && !checked){
									return prev.filter(el => el !== item.observer_id);
								} else if (!prev.includes(item.observer_id) && checked){
									return [ ...prev, item.observer_id, ];
								}
								
								return prev;
							})}
						/>
					}
				</List.Item>;
			}}
		/>
	);
}
